export const SOLUTION_LANDINGS = {
    "credit-line-ad-accounts": {
        title: {
            en: "Credit Line Ad Accounts",
            pt: "Contas de Anúncio com Credit Line",
            es: "Cuentas de Anuncios con Credit Line",
            ru: "Рекламные аккаунты с Credit Line",
            tr: "Credit Line Reklam Hesapları",
        },
        subtitle: {
            en: "Scale ad spend with agency-funded account infrastructure and stablecoin top-ups.",
            pt: "Escalone investimento com infraestrutura de contas financiada por agência e recarga em stablecoin.",
            es: "Escala inversión con infraestructura financiada por agencia y recargas en stablecoins.",
            ru: "Масштабируйте рекламу через агентскую инфраструктуру и пополнение в стейблкоинах.",
            tr: "Ajans fonlu hesap altyapısı ve stablecoin top-up ile reklam harcamasını ölçekleyin.",
        },
        seoDescription: {
            en: "Adrise Credit Line ad accounts for Meta, Google, TikTok and more. Crypto-only top-up, stable settlement, and high-volume growth operations.",
            pt: "Contas Credit Line da Adrise para Meta, Google, TikTok e mais. Recarga cripto, liquidação estável e operação para alto volume.",
            es: "Cuentas Credit Line de Adrise para Meta, Google, TikTok y más. Recarga cripto y operación estable para alto volumen.",
            ru: "Credit Line аккаунты Adrise для Meta, Google, TikTok и др. Крипто-пополнение и стабильные операции для больших бюджетов.",
            tr: "Meta, Google, TikTok ve daha fazlası için Adrise Credit Line hesapları. Kripto top-up ve yüksek hacim için stabil operasyon.",
        },
        bullets: {
            en: ["Agency-funded platform billing", "Deterministic deposit address per order", "On-chain confirmation based wallet credit", "Operational continuity for high daily spend"],
            pt: ["Faturamento da plataforma financiado pela agência", "Endereço determinístico por pedido", "Crédito por confirmação on-chain", "Continuidade operacional em alto gasto diário"],
            es: ["Facturación de plataforma financiada por agencia", "Dirección determinística por pedido", "Crédito por confirmación on-chain", "Continuidad operativa para alto gasto diario"],
            ru: ["Платежи платформы финансируются агентством", "Детерминированный адрес на каждый заказ", "Зачисление по on-chain подтверждениям", "Операционная непрерывность при больших бюджетах"],
            tr: ["Platform faturalaması ajans tarafından fonlanır", "Sipariş başına deterministik adres", "On-chain onaya bağlı bakiye yansıması", "Yüksek günlük harcamada operasyon sürekliliği"],
        },
        faq: {
            en: [
                {
                    q: "Who is this model best for?",
                    a: "Teams spending $50k+ monthly that need stable billing and fast scale execution.",
                },
                {
                    q: "What currencies are supported?",
                    a: "USDT-TRC20, USDT-ERC20, and USDC-ERC20 in the current production stack.",
                },
            ],
            pt: [
                {
                    q: "Para quem esse modelo é ideal?",
                    a: "Times com gasto mensal acima de $50k que precisam de estabilidade e escala rápida.",
                },
                {
                    q: "Quais moedas são suportadas?",
                    a: "USDT-TRC20, USDT-ERC20 e USDC-ERC20 no stack atual.",
                },
            ],
            es: [
                {
                    q: "¿Para quién es ideal este modelo?",
                    a: "Equipos con más de $50k/mes que requieren estabilidad y ejecución rápida.",
                },
                {
                    q: "¿Qué monedas se aceptan?",
                    a: "USDT-TRC20, USDT-ERC20 y USDC-ERC20 en el stack actual.",
                },
            ],
            ru: [
                {
                    q: "Для кого подходит эта модель?",
                    a: "Для команд с бюджетом от $50k/мес, которым важны стабильность и быстрая масштабируемость.",
                },
                {
                    q: "Какие валюты поддерживаются?",
                    a: "USDT-TRC20, USDT-ERC20 и USDC-ERC20 в текущем продакшене.",
                },
            ],
            tr: [
                {
                    q: "Bu model kimler için ideal?",
                    a: "Aylık $50k+ harcayan ve stabil faturalama + hızlı ölçekleme isteyen ekipler için.",
                },
                {
                    q: "Hangi para birimleri destekleniyor?",
                    a: "Mevcut prod stack’te USDT-TRC20, USDT-ERC20 ve USDC-ERC20.",
                },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1611174743420-3d7df880ce32?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "meta-agency-ad-accounts": {
        title: {
            en: "Meta Agency Ad Accounts",
            pt: "Contas de Agência Meta",
            es: "Cuentas de Agencia Meta",
            ru: "Агентские аккаунты Meta",
            tr: "Meta Ajans Reklam Hesapları",
        },
        subtitle: {
            en: "Whitelisted Meta setup for teams that need stable scale and faster resolution lanes.",
            pt: "Estrutura Meta whitelisted para times que precisam de escala estável e resolução rápida.",
            es: "Estructura Meta whitelisted para equipos que buscan escala estable y resolución rápida.",
            ru: "Whitelisted инфраструктура Meta для стабильного масштабирования и ускоренной эскалации.",
            tr: "Stabil ölçekleme ve hızlı çözüm kanalı isteyen ekipler için whitelisted Meta altyapısı.",
        },
        seoDescription: {
            en: "Meta agency ad accounts with operational controls, support lanes, and credit-line funding structure for serious advertisers.",
            pt: "Contas Meta de agência com controles operacionais, suporte e estrutura Credit Line para anunciantes sérios.",
            es: "Cuentas Meta de agencia con controles operativos, soporte y modelo Credit Line.",
            ru: "Агентские Meta аккаунты с операционными контролями, поддержкой и Credit Line финансированием.",
            tr: "Operasyon kontrolleri, destek kanalları ve Credit Line modeliyle Meta ajans hesapları.",
        },
        bullets: {
            en: ["High-trust account architecture", "Faster incident escalation path", "Gray-hat compatible operations lane", "Account continuity playbooks"],
            pt: ["Arquitetura de conta de alta confiança", "Escalonamento de incidentes mais rápido", "Lane operacional compatível com gray-hat", "Playbooks de continuidade"],
            es: ["Arquitectura de cuenta de alta confianza", "Escalado de incidentes más rápido", "Lane operativo compatible con gray-hat", "Playbooks de continuidad"],
            ru: ["Высокий уровень trust-архитектуры", "Быстрый путь эскалации инцидентов", "Операционный lane для gray-hat вертикалей", "Playbook непрерывности"],
            tr: ["Yüksek güvenli hesap mimarisi", "Daha hızlı incident escalation", "Gray-hat uyumlu operasyon kanalı", "Hesap sürekliliği playbook’ları"],
        },
        faq: {
            en: [
                {
                    q: "Do you support casino & gambling?",
                    a: "Yes — on every platform for licensed operators, through a dedicated compliance lane (10% → 7% volumetric fee).",
                },
                {
                    q: "How quickly can operations recover from issues?",
                    a: "With proper runbooks and account pool strategy, recovery windows are typically minutes not days.",
                },
            ],
            pt: [
                {
                    q: "Suporta casino & gambling?",
                    a: "Sim — em todas as plataformas para operadores licenciados, via lane dedicado de compliance (fee volumétrico 10% → 7%).",
                },
                {
                    q: "Qual a velocidade de recuperação?",
                    a: "Com runbooks e pool de contas, a recuperação tende a levar minutos, não dias.",
                },
            ],
            es: [
                {
                    q: "¿Soportan casino & gambling?",
                    a: "Sí — en todas las plataformas para operadores con licencia, mediante un lane dedicado de compliance (fee volumétrico 10% → 7%).",
                },
                {
                    q: "¿Qué tan rápida es la recuperación?",
                    a: "Con runbooks y pool de cuentas, la recuperación suele medirse en minutos.",
                },
            ],
            ru: [
                {
                    q: "Поддерживается ли casino & gambling?",
                    a: "Да — на всех платформах для лицензированных операторов, через отдельный compliance-lane (объёмная комиссия 10% → 7%).",
                },
                {
                    q: "Насколько быстрое восстановление?",
                    a: "При корректных runbook’ах и пуле аккаунтов восстановление обычно занимает минуты.",
                },
            ],
            tr: [
                {
                    q: "Casino & Gambling desteği var mı?",
                    a: "Evet — lisanslı operatörler için tüm platformlarda, özel uyum kanalı üzerinden (hacimsel %10 → %7 komisyon).",
                },
                {
                    q: "Sorunlarda toparlanma hızı nedir?",
                    a: "Doğru runbook ve hesap havuzuyla toparlanma genelde günler değil dakikalar seviyesindedir.",
                },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1516321497487-e288fb19713f?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "google-agency-ad-accounts": {
        title: {
            en: "Google Agency Ad Accounts",
            pt: "Contas de Agência Google",
            es: "Cuentas de Agencia Google",
            ru: "Агентские аккаунты Google",
            tr: "Google Ajans Reklam Hesapları",
        },
        subtitle: {
            en: "MCC-governed setup for stable Google scaling across search, shopping, and PMax.",
            pt: "Estrutura com governança MCC para escala estável em Search, Shopping e PMax.",
            es: "Estructura con gobernanza MCC para escalar en Search, Shopping y PMax.",
            ru: "MCC-модель для стабильного масштабирования Google Search, Shopping и PMax.",
            tr: "Search, Shopping ve PMax tarafında stabil büyüme için MCC yönetişimli kurulum.",
        },
        seoDescription: {
            en: "Whitelisted Google agency accounts and MCC controls for policy resilience, billing reliability, and performance continuity.",
            pt: "Contas Google de agência com controles MCC para resiliência de policy e continuidade de performance.",
            es: "Cuentas Google de agencia con controles MCC para resiliencia de policy y continuidad de performance.",
            ru: "Whitelisted Google аккаунты с MCC-контролями для устойчивости к policy-рискам.",
            tr: "Policy dayanıklılığı ve performans sürekliliği için whitelisted Google hesapları ve MCC kontrolleri.",
        },
        bullets: {
            en: ["MCC operational governance", "Cleaner policy handling flow", "PMax + Search scale readiness", "Reduced billing interruption risk"],
            pt: ["Governança operacional MCC", "Fluxo de policy mais limpo", "Pronto para escalar PMax + Search", "Menor risco de interrupção de billing"],
            es: ["Gobernanza operativa MCC", "Flujo de policy más limpio", "Preparado para escalar PMax + Search", "Menor riesgo de interrupciones de billing"],
            ru: ["Операционная governance в MCC", "Более чистый policy-flow", "Готовность к масштабу PMax + Search", "Снижение риска billing-пауз"],
            tr: ["MCC operasyon yönetişimi", "Daha temiz policy yönetim akışı", "PMax + Search ölçekleme hazırlığı", "Faturalama kesintisi riskinde azalma"],
        },
        faq: {
            en: [
                {
                    q: "Can this model support high-volume finance campaigns?",
                    a: "Yes, with compliance-first setup and proper account governance.",
                },
                {
                    q: "How does this impact account stability?",
                    a: "Stability improves when policy, billing, and campaign structure are managed together under one operating system.",
                },
            ],
            pt: [
                {
                    q: "Esse modelo suporta campanhas financeiras de alto volume?",
                    a: "Sim, com setup orientado a compliance e governança correta.",
                },
                {
                    q: "Qual o impacto na estabilidade?",
                    a: "A estabilidade cresce quando policy, billing e estrutura de campanha são geridos juntos.",
                },
            ],
            es: [
                {
                    q: "¿Este modelo soporta campañas financieras de alto volumen?",
                    a: "Sí, con setup orientado a compliance y buena gobernanza.",
                },
                {
                    q: "¿Cómo impacta la estabilidad?",
                    a: "Mejora cuando policy, billing y estructura de campaña se gestionan en conjunto.",
                },
            ],
            ru: [
                {
                    q: "Подходит ли модель для финансовых кампаний большого объема?",
                    a: "Да, при compliance-first подходе и корректной governance.",
                },
                {
                    q: "Как это влияет на стабильность?",
                    a: "Стабильность растет, когда policy, billing и структура кампаний управляются как единая система.",
                },
            ],
            tr: [
                {
                    q: "Model yüksek hacimli finans kampanyalarına uygun mu?",
                    a: "Evet, uyum odaklı kurulum ve doğru yönetişimle uygundur.",
                },
                {
                    q: "Hesap stabilitesine etkisi nedir?",
                    a: "Policy, billing ve kampanya yapısı tek sistemde yönetildiğinde stabilite anlamlı biçimde artar.",
                },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1485217988980-11786ced9454?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "tiktok-agency-ad-accounts": {
        title: {
            en: "TikTok Agency Ad Accounts",
            pt: "Contas de Agência TikTok",
            es: "Cuentas de Agencia TikTok",
            ru: "Агентские аккаунты TikTok",
            tr: "TikTok Ajans Reklam Hesapları",
        },
        subtitle: {
            en: "Creative-velocity-friendly setup for scaling TikTok without constant restart cycles.",
            pt: "Estrutura orientada a velocidade criativa para escalar no TikTok sem ciclos de reinício.",
            es: "Estructura orientada a velocidad creativa para escalar TikTok sin reinicios constantes.",
            ru: "Инфраструктура под высокую скорость креативов для масштабирования TikTok без постоянных рестартов.",
            tr: "Sürekli reset döngüsüne girmeden TikTok ölçeklemek için kreatif-hız odaklı kurulum.",
        },
        seoDescription: {
            en: "TikTok agency ad account setup for creative throughput, stable scaling, and rapid operational iteration.",
            pt: "Setup TikTok de agência para throughput criativo, escala estável e iteração rápida.",
            es: "Setup TikTok de agencia para throughput creativo, escala estable e iteración rápida.",
            ru: "Агентская TikTok-модель для высокой скорости креативов и устойчивого масштабирования.",
            tr: "Kreatif throughput, stabil ölçekleme ve hızlı iterasyon için TikTok ajans kurulumu.",
        },
        bullets: {
            en: ["Creative throughput operating model", "Audience rotation discipline", "Scale campaign promotion logic", "Operational fallback readiness"],
            pt: ["Modelo operacional de throughput criativo", "Disciplina de rotação de audiência", "Lógica de promoção para campanha de escala", "Prontidão de fallback operacional"],
            es: ["Modelo operativo de throughput creativo", "Disciplina de rotación de audiencias", "Lógica de promoción para campañas de escala", "Preparación de fallback operativo"],
            ru: ["Операционная модель creative throughput", "Дисциплина ротации аудиторий", "Логика перевода победителей в scale", "Готовность fallback-сценариев"],
            tr: ["Kreatif throughput operasyon modeli", "Kitle rotasyonu disiplini", "Kazananları scale’e taşıma mantığı", "Operasyonel fallback hazırlığı"],
        },
        faq: {
            en: [
                {
                    q: "What breaks most TikTok scaling attempts?",
                    a: "Low creative velocity and weak campaign hygiene are the two biggest failure points.",
                },
                {
                    q: "How should teams structure iteration?",
                    a: "Daily creative batches, short test windows, and strict winner promotion workflow.",
                },
            ],
            pt: [
                {
                    q: "O que quebra a maioria das escalas no TikTok?",
                    a: "Baixa velocidade criativa e higiene fraca de campanha.",
                },
                {
                    q: "Como estruturar iteração?",
                    a: "Lotes criativos diários, janelas curtas de teste e promoção rígida de vencedores.",
                },
            ],
            es: [
                {
                    q: "¿Qué rompe la mayoría de escalados en TikTok?",
                    a: "Baja velocidad creativa y mala higiene de campañas.",
                },
                {
                    q: "¿Cómo estructurar la iteración?",
                    a: "Lotes creativos diarios, ventanas cortas y promoción estricta de ganadores.",
                },
            ],
            ru: [
                {
                    q: "Что чаще всего ломает масштабирование TikTok?",
                    a: "Низкая скорость креативов и слабая дисциплина кампаний.",
                },
                {
                    q: "Как выстроить итерации?",
                    a: "Ежедневные пакеты креативов, короткие тесты и строгий workflow перевода победителей.",
                },
            ],
            tr: [
                {
                    q: "TikTok’ta çoğu ölçekleme neden kırılıyor?",
                    a: "Düşük kreatif hızı ve zayıf kampanya hijyeni en kritik iki sebep.",
                },
                {
                    q: "İterasyon nasıl kurulmalı?",
                    a: "Günlük kreatif batch, kısa test penceresi ve sıkı winner promotion akışıyla.",
                },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1611606063065-ee7946f0787a?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "crypto-funded-ad-accounts": {
        title: {
            en: "Crypto-Funded Ad Accounts",
            pt: "Contas de Anúncio com Funding em Cripto",
            es: "Cuentas Publicitarias con Fondeo Cripto",
            ru: "Крипто-финансируемые рекламные аккаунты",
            tr: "Kripto Fonlu Reklam Hesapları",
        },
        subtitle: {
            en: "Stablecoin settlement rails for faster treasury cycles and cleaner ad operations.",
            pt: "Rails de liquidação em stablecoin para tesouraria mais rápida e operação mais limpa.",
            es: "Rails de liquidación en stablecoins para tesorería más rápida y operación más limpia.",
            ru: "Стейблкоин-расчеты для ускорения treasury-циклов и более чистых ad-операций.",
            tr: "Daha hızlı treasury döngüsü ve temiz reklam operasyonu için stablecoin mutabakat hattı.",
        },
        seoDescription: {
            en: "Crypto-funded ad account infrastructure with deterministic addressing and confirmation-based wallet credit flow.",
            pt: "Infraestrutura de contas com funding em cripto, endereçamento determinístico e crédito por confirmação.",
            es: "Infraestructura de cuentas con fondeo cripto, direccionamiento determinístico y crédito por confirmación.",
            ru: "Инфраструктура крипто-фандинга с детерминированной адресацией и зачислением по подтверждениям.",
            tr: "Deterministik adresleme ve onaya bağlı cüzdan kredisiyle kripto fonlu reklam hesabı altyapısı.",
        },
        bullets: {
            en: ["Order-specific settlement tracing", "Fast global stablecoin transfer", "Wallet crediting by confirmation thresholds", "Treasury visibility for operations teams"],
            pt: ["Rastreio de liquidação por pedido", "Transferência global rápida em stablecoin", "Crédito por limiar de confirmação", "Visibilidade de tesouraria para operações"],
            es: ["Trazabilidad de liquidación por pedido", "Transferencia global rápida en stablecoins", "Crédito por umbral de confirmaciones", "Visibilidad de tesorería para operaciones"],
            ru: ["Трассировка расчетов по каждому заказу", "Быстрые глобальные переводы в стейблкоинах", "Зачисление по порогам подтверждений", "Прозрачность treasury для ops-команды"],
            tr: ["Sipariş bazlı mutabakat takibi", "Hızlı global stablecoin transferi", "Onay eşiğine göre bakiye yansıması", "Ops ekipleri için treasury görünürlüğü"],
        },
        faq: {
            en: [
                {
                    q: "Why not rely on cards only?",
                    a: "At scale, card declines and cross-border friction create expensive downtime. Stablecoin rails are more predictable.",
                },
                {
                    q: "How is settlement mapped to each order?",
                    a: "Each order has unique address + amount + confirmation conditions, allowing deterministic matching.",
                },
            ],
            pt: [
                {
                    q: "Por que não usar só cartão?",
                    a: "Em escala, declínios e fricção cross-border geram downtime caro. Stablecoins são mais previsíveis.",
                },
                {
                    q: "Como a liquidação é vinculada ao pedido?",
                    a: "Cada pedido usa endereço único + valor + condição de confirmação para match determinístico.",
                },
            ],
            es: [
                {
                    q: "¿Por qué no usar solo tarjeta?",
                    a: "A escala, los rechazos y fricción internacional generan downtime costoso. Stablecoins son más previsibles.",
                },
                {
                    q: "¿Cómo se vincula la liquidación al pedido?",
                    a: "Cada pedido usa dirección única + importe + confirmaciones para matching determinístico.",
                },
            ],
            ru: [
                {
                    q: "Почему не использовать только карты?",
                    a: "На масштабе card-decline и cross-border трение дают дорогие простои. Стейблкоины предсказуемее.",
                },
                {
                    q: "Как расчет привязывается к заказу?",
                    a: "У каждого заказа уникальные адрес, сумма и условия подтверждений для детерминированного сопоставления.",
                },
            ],
            tr: [
                {
                    q: "Neden sadece karta bağlı kalmıyoruz?",
                    a: "Büyük ölçekte kart reddi ve sınır ötesi sürtünme pahalı kesinti yaratır. Stablecoin hattı daha öngörülebilir.",
                },
                {
                    q: "Mutabakat siparişe nasıl bağlanıyor?",
                    a: "Her siparişte benzersiz adres + tutar + onay koşulu olduğu için deterministik eşleme yapılır.",
                },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "facebook-ad-account-disabled-recovery": {
        title: {
            en: "Facebook Ad Account Disabled Recovery",
            pt: "Recuperação de Conta de Anúncios Facebook Desativada",
            es: "Recuperación de Cuenta de Anuncios de Facebook Deshabilitada",
            ru: "Восстановление отключенного Facebook ad account",
            tr: "Facebook Reklam Hesabı Kapanma Sonrası Operasyon",
        },
        subtitle: {
            en: "Operational playbook to recover campaign continuity when a Facebook ad account is disabled.",
            pt: "Playbook operacional para recuperar continuidade quando uma conta Facebook é desativada.",
            es: "Playbook operativo para recuperar continuidad cuando una cuenta de Facebook se deshabilita.",
            ru: "Операционный playbook для сохранения непрерывности кампаний после отключения аккаунта.",
            tr: "Facebook hesabı kapanınca kampanya sürekliliğini korumak için operasyon playbook’u.",
        },
        seoDescription: {
            en: "Learn how to handle Facebook ad account disabled incidents with fast transition workflows, balance continuity, and compliance-first escalation.",
            pt: "Veja como lidar com conta Facebook desativada com transição rápida, continuidade de saldo e escalonamento compliance-first.",
            es: "Aprende a gestionar cuenta de Facebook deshabilitada con transición rápida, continuidad de saldo y escalado compliance-first.",
            ru: "Как обрабатывать отключение Facebook аккаунта: быстрый переход, сохранение баланса и compliance-first эскалация.",
            tr: "Facebook hesabı kapanma durumunda hızlı geçiş, bakiye sürekliliği ve uyum odaklı eskalasyon akışını öğrenin.",
        },
        bullets: {
            en: ["Incident triage workflow", "Fallback account allocation", "Balance continuity process", "Escalation and compliance documentation"],
            pt: ["Fluxo de triagem de incidentes", "Alocação de conta fallback", "Processo de continuidade de saldo", "Escalonamento e documentação de compliance"],
            es: ["Flujo de triage de incidentes", "Asignación de cuenta fallback", "Proceso de continuidad de saldo", "Escalado y documentación de compliance"],
            ru: ["Incident triage workflow", "Fallback allocation", "Процесс сохранения баланса", "Эскалация и compliance-документация"],
            tr: ["Incident triage akışı", "Fallback hesap tahsisi", "Bakiye süreklilik süreci", "Eskalasyon ve uyum dokümantasyonu"],
        },
        faq: {
            en: [
                {
                    q: "How fast can campaigns resume?",
                    a: "With prepared fallback operations, many teams resume within hours rather than days.",
                },
                {
                    q: "Is balance transfer supported?",
                    a: "Operationally yes, depending on account status and platform policy constraints.",
                },
            ],
            pt: [
                { q: "Qual a velocidade de retomada?", a: "Com fallback preparado, muitas equipes retomam em horas, não dias." },
                { q: "Há transferência de saldo?", a: "Operacionalmente sim, conforme status e políticas da plataforma." },
            ],
            es: [
                { q: "¿Qué tan rápido se reanuda?", a: "Con fallback preparado, muchos equipos retoman en horas." },
                { q: "¿Se puede transferir saldo?", a: "Sí operativamente, según estado de cuenta y políticas." },
            ],
            ru: [
                { q: "Как быстро возобновляются кампании?", a: "При готовом fallback большинство команд возвращаются в течение часов." },
                { q: "Поддерживается ли перенос баланса?", a: "Да, операционно возможно с учетом статуса и policy-ограничений." },
            ],
            tr: [
                { q: "Kampanyalar ne kadar hızlı döner?", a: "Fallback hazırsa birçok ekip günler yerine saatler içinde devam eder." },
                { q: "Bakiye transferi mümkün mü?", a: "Evet, hesap durumu ve platform politikalarına göre operasyonel olarak mümkündür." },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1551434678-e076c223a692?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "high-spend-google-ads-accounts": {
        title: {
            en: "High Spend Google Ads Accounts",
            pt: "Contas Google Ads para Alto Investimento",
            es: "Cuentas Google Ads para Alto Gasto",
            ru: "Google Ads аккаунты для больших бюджетов",
            tr: "Yüksek Harcama için Google Ads Hesapları",
        },
        subtitle: {
            en: "Google account setup for teams targeting aggressive monthly spend growth with governance controls.",
            pt: "Setup de contas Google para equipes com crescimento agressivo de gasto e controles de governança.",
            es: "Setup de cuentas Google para equipos con crecimiento agresivo de gasto y controles de gobernanza.",
            ru: "Google setup для команд с агрессивным ростом бюджета и governance-контролями.",
            tr: "Agresif aylık harcama büyümesi hedefleyen ekipler için yönetişim kontrollü Google hesap setup’ı.",
        },
        seoDescription: {
            en: "Scale Google Ads spend with structured MCC governance, billing continuity, and compliance-led campaign operations.",
            pt: "Escalone gasto no Google Ads com governança MCC, continuidade de billing e operação orientada a compliance.",
            es: "Escala Google Ads con gobernanza MCC, continuidad de billing y operación orientada a compliance.",
            ru: "Масштабируйте Google Ads через MCC governance, billing continuity и compliance-подход.",
            tr: "MCC yönetişimi, faturalama sürekliliği ve uyum odaklı operasyonla Google Ads harcamasını ölçekleyin.",
        },
        bullets: {
            en: ["MCC governance model", "High-budget billing continuity", "Performance + compliance checklist", "Scale playbook for Search/PMax"],
            pt: ["Modelo de governança MCC", "Continuidade de billing para alto orçamento", "Checklist performance + compliance", "Playbook de escala Search/PMax"],
            es: ["Modelo de gobernanza MCC", "Continuidad de billing para alto presupuesto", "Checklist de performance + compliance", "Playbook de escala Search/PMax"],
            ru: ["MCC governance", "Billing continuity для больших бюджетов", "Performance + compliance checklist", "Scale playbook для Search/PMax"],
            tr: ["MCC yönetişim modeli", "Yüksek bütçede faturalama sürekliliği", "Performans + uyum checklist’i", "Search/PMax için ölçekleme playbook’u"],
        },
        faq: {
            en: [
                { q: "Can this support finance and lead-gen campaigns?", a: "Yes, with policy-led setup and strict account governance." },
                { q: "What is the key stability factor?", a: "Consistency across policy, billing profile, and campaign architecture." },
            ],
            pt: [
                { q: "Suporta campanhas financeiras e lead-gen?", a: "Sim, com setup orientado a políticas e governança rígida." },
                { q: "Qual fator-chave de estabilidade?", a: "Consistência entre policy, perfil de cobrança e arquitetura de campanha." },
            ],
            es: [
                { q: "¿Soporta campañas financieras y lead-gen?", a: "Sí, con setup orientado a políticas y gobernanza estricta." },
                { q: "¿Factor clave de estabilidad?", a: "Consistencia entre policy, billing profile y arquitectura de campaña." },
            ],
            ru: [
                { q: "Подходит для finance и lead-gen кампаний?", a: "Да, при policy-led настройке и строгой governance." },
                { q: "Ключ к стабильности?", a: "Согласованность policy, billing-профиля и архитектуры кампаний." },
            ],
            tr: [
                { q: "Finance ve lead-gen kampanyaları için uygun mu?", a: "Evet, policy odaklı kurulum ve sıkı yönetişimle uygundur." },
                { q: "Stabilitede ana faktör nedir?", a: "Policy, billing profili ve kampanya mimarisinde tutarlılık." },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1556740738-b6a63e27c4df?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "tiktok-whitelisted-accounts": {
        title: {
            en: "TikTok Whitelisted Accounts",
            pt: "Contas TikTok Whitelisted",
            es: "Cuentas TikTok Whitelisted",
            ru: "Whitelisted аккаунты TikTok",
            tr: "TikTok Whitelisted Hesaplar",
        },
        subtitle: {
            en: "TikTok account operations designed for creative velocity and sustainable spend scaling.",
            pt: "Operação de contas TikTok desenhada para velocidade criativa e escala sustentável.",
            es: "Operación de cuentas TikTok para velocidad creativa y escala sostenible.",
            ru: "TikTok-операции для высокой скорости креативов и устойчивого масштабирования.",
            tr: "Kreatif hız ve sürdürülebilir harcama ölçeklemesi için TikTok hesap operasyonu.",
        },
        seoDescription: {
            en: "Run TikTok campaigns with whitelisted account workflows, creative throughput systems, and fallback operations for continuity.",
            pt: "Rode campanhas TikTok com workflow whitelisted, throughput criativo e fallback para continuidade.",
            es: "Ejecuta TikTok con workflows whitelisted, throughput creativo y fallback para continuidad.",
            ru: "Запускайте TikTok с whitelisted workflow, creative throughput и fallback-процессами.",
            tr: "Whitelisted workflow, kreatif throughput ve fallback süreçleriyle TikTok kampanyalarını yönetin.",
        },
        bullets: {
            en: ["Creative throughput workflow", "Audience rotation cadence", "Scale winner promotion logic", "Operational continuity fallback"],
            pt: ["Workflow de throughput criativo", "Cadência de rotação de audiências", "Lógica de promoção de vencedores", "Fallback de continuidade operacional"],
            es: ["Workflow de throughput creativo", "Cadencia de rotación de audiencias", "Lógica de promoción de ganadores", "Fallback de continuidad operativa"],
            ru: ["Creative throughput workflow", "Ротация аудиторий", "Логика продвижения победителей", "Fallback непрерывности"],
            tr: ["Kreatif throughput workflow", "Kitle rotasyon kadansı", "Kazananları scale’e taşıma mantığı", "Operasyon süreklilik fallback’i"],
        },
        faq: {
            en: [
                { q: "What causes TikTok volatility?", a: "Low creative throughput and weak testing cadence are common causes." },
                { q: "How to protect spend continuity?", a: "Use parallel account allocation and fast winner migration routines." },
            ],
            pt: [
                { q: "O que causa volatilidade no TikTok?", a: "Baixo throughput criativo e cadence fraca de testes." },
                { q: "Como proteger continuidade?", a: "Alocação paralela de contas e migração rápida de vencedores." },
            ],
            es: [
                { q: "¿Qué causa volatilidad en TikTok?", a: "Bajo throughput creativo y cadencia débil de tests." },
                { q: "¿Cómo proteger continuidad?", a: "Asignación paralela de cuentas y migración rápida de ganadores." },
            ],
            ru: [
                { q: "Что вызывает волатильность TikTok?", a: "Низкая скорость креативов и слабая тестовая дисциплина." },
                { q: "Как защитить непрерывность расхода?", a: "Параллельное распределение аккаунтов и быстрый перенос победителей." },
            ],
            tr: [
                { q: "TikTok’ta oynaklığın ana sebebi nedir?", a: "Düşük kreatif hızı ve zayıf test ritmi en yaygın sebeptir." },
                { q: "Harcama sürekliliği nasıl korunur?", a: "Paralel hesap dağılımı ve hızlı winner migration rutiniyle." },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1611605698335-8b1569810432?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "agency-ad-account-vs-personal": {
        title: {
            en: "Agency Ad Account vs Personal Account",
            pt: "Conta de Agência vs Conta Pessoal",
            es: "Cuenta de Agencia vs Cuenta Personal",
            ru: "Агентский аккаунт vs персональный",
            tr: "Ajans Reklam Hesabı vs Bireysel Hesap",
        },
        subtitle: {
            en: "Comparison guide for teams deciding between personal ad accounts and agency-managed infrastructure.",
            pt: "Guia comparativo para times decidindo entre conta pessoal e infraestrutura de agência.",
            es: "Guía comparativa para equipos entre cuenta personal e infraestructura de agencia.",
            ru: "Сравнение для команд между персональными и агентскими аккаунтами.",
            tr: "Bireysel hesap ile ajans yönetimli altyapı arasında karar veren ekipler için karşılaştırma rehberi.",
        },
        seoDescription: {
            en: "Compare agency ad accounts vs personal accounts across stability, billing, support, and scaling operations.",
            pt: "Compare contas de agência vs pessoais em estabilidade, billing, suporte e escala.",
            es: "Compara cuentas de agencia vs personales en estabilidad, billing, soporte y escala.",
            ru: "Сравнение агентских и персональных аккаунтов: стабильность, биллинг, поддержка и масштаб.",
            tr: "Ajans ve bireysel reklam hesaplarını stabilite, faturalama, destek ve ölçekleme açısından karşılaştırın.",
        },
        bullets: {
            en: ["Billing model comparison", "Stability and continuity analysis", "Support and escalation paths", "Best-fit use-case matrix"],
            pt: ["Comparação de modelo de billing", "Análise de estabilidade e continuidade", "Canais de suporte e escalonamento", "Matriz de casos de uso"],
            es: ["Comparación de modelo de billing", "Análisis de estabilidad y continuidad", "Canales de soporte y escalado", "Matriz de casos de uso"],
            ru: ["Сравнение billing-моделей", "Анализ стабильности", "Каналы поддержки и эскалации", "Матрица best-fit кейсов"],
            tr: ["Faturalama modeli karşılaştırması", "Stabilite ve süreklilik analizi", "Destek ve eskalasyon kanalları", "Use-case uygunluk matrisi"],
        },
        faq: {
            en: [
                { q: "When should teams use agency accounts?", a: "When they need scale support, billing continuity, and structured operations." },
                { q: "Are personal accounts enough for growth?", a: "For early stages yes, but high-volume teams usually need stronger operational systems." },
            ],
            pt: [
                { q: "Quando usar contas de agência?", a: "Quando precisa de escala, continuidade de billing e operação estruturada." },
                { q: "Conta pessoal basta para crescer?", a: "No início sim; em alto volume normalmente é necessário sistema mais robusto." },
            ],
            es: [
                { q: "¿Cuándo usar cuentas de agencia?", a: "Cuando necesitas escala, continuidad de billing y operación estructurada." },
                { q: "¿La cuenta personal alcanza para crecer?", a: "Al inicio sí; con alto volumen suele requerirse sistema más robusto." },
            ],
            ru: [
                { q: "Когда использовать агентские аккаунты?", a: "Когда нужны масштаб, стабильный биллинг и структурированные операции." },
                { q: "Хватает ли персонального аккаунта для роста?", a: "На старте — да, но для больших объемов нужен более сильный операционный контур." },
            ],
            tr: [
                { q: "Ajans hesapları ne zaman gerekli olur?", a: "Ölçek desteği, faturalama sürekliliği ve yapılandırılmış operasyon gerektiğinde." },
                { q: "Bireysel hesap büyümeye yeter mi?", a: "Başlangıçta evet; yüksek hacimde daha güçlü bir operasyon sistemi gerekir." },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "agency-ad-account-pricing-guide": {
        title: {
            en: "Agency Ad Account Pricing Guide",
            pt: "Guia de Preços de Conta de Agência",
            es: "Guía de Precios de Cuenta de Agencia",
            ru: "Гайд по pricing агентских аккаунтов",
            tr: "Ajans Reklam Hesabı Fiyatlandırma Rehberi",
        },
        subtitle: {
            en: "Understand fee tiers, volume-based pricing logic, and how to plan monthly media operations cost.",
            pt: "Entenda tiers de fee, lógica de preço por volume e planejamento mensal de custo de mídia.",
            es: "Comprende tiers de fee, lógica por volumen y planificación mensual de costo de medios.",
            ru: "Понимание fee-уровней, объемной модели pricing и планирования месячных расходов.",
            tr: "Fee katmanları, hacim bazlı fiyat mantığı ve aylık medya operasyon maliyeti planlamasını anlayın.",
        },
        seoDescription: {
            en: "Agency ad account pricing explained: no monthly subscription, volume-based top-up fee structure, and cost planning framework.",
            pt: "Preços de conta de agência explicados: sem assinatura mensal, fee de recarga por volume e framework de custo.",
            es: "Precios de cuenta de agencia: sin suscripción mensual, fee de recarga por volumen y framework de coste.",
            ru: "Pricing агентских аккаунтов: без ежемесячной подписки, объемные комиссии за пополнение и фреймворк планирования.",
            tr: "Ajans reklam hesabı fiyatlandırması: aylık abonelik yok, hacim bazlı yükleme komisyonu ve maliyet planlama çerçevesi.",
        },
        bullets: {
            en: ["No-subscription model", "Volume fee breakdown", "Cashback eligibility tiers", "Cost forecasting examples"],
            pt: ["Modelo sem assinatura", "Detalhamento de fee por volume", "Tiers de elegibilidade de cashback", "Exemplos de previsão de custo"],
            es: ["Modelo sin suscripción", "Desglose de fee por volumen", "Tiers de elegibilidad de cashback", "Ejemplos de forecast de coste"],
            ru: ["Модель без подписки", "Разбивка объемных fee", "Уровни cashback eligibility", "Примеры cost forecasting"],
            tr: ["Aboneliksiz model", "Hacim fee kırılımı", "Cashback uygunluk katmanları", "Maliyet öngörü örnekleri"],
        },
        faq: {
            en: [
                { q: "How do fees change as spend grows?", a: "Fees generally decrease with higher qualified monthly volume tiers." },
                { q: "How should teams forecast total cost?", a: "There is no fixed subscription — combine projected monthly spend with the volumetric fee tier that applies to it." },
            ],
            pt: [
                { q: "Como o fee muda com o crescimento?", a: "Normalmente reduz conforme tiers de volume mensal qualificado." },
                { q: "Como prever custo total?", a: "Não há assinatura fixa — combine o spend projetado com o tier de fee aplicável." },
            ],
            es: [
                { q: "¿Cómo cambia el fee al crecer?", a: "Suele reducirse según tiers de volumen mensual cualificado." },
                { q: "¿Cómo prever coste total?", a: "No hay suscripción fija — combina el spend proyectado con el tier de fee aplicable." },
            ],
            ru: [
                { q: "Как меняются комиссии при росте?", a: "Обычно снижаются при росте квалифицированного месячного объема." },
                { q: "Как прогнозировать общий расход?", a: "Фиксированной подписки нет — сочетайте прогноз spend с применимым tier комиссии." },
            ],
            tr: [
                { q: "Harcama büyüdükçe fee nasıl değişir?", a: "Genelde nitelikli aylık hacim arttıkça fee oranı düşer." },
                { q: "Toplam maliyet nasıl öngörülür?", a: "Sabit abonelik yoktur — planlanan spend ile geçerli fee kademesi birlikte hesaplanır." },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "whitelisted-ad-accounts": {
        title: {
            en: "Whitelisted Ad Accounts",
            pt: "Contas de Anúncio Whitelisted",
            es: "Cuentas de Anuncios Whitelisted",
            ru: "Whitelisted рекламные аккаунты",
            tr: "Whitelisted Reklam Hesapları",
        },
        subtitle: {
            en: "What whitelisted ad accounts mean operationally and how they improve campaign continuity.",
            pt: "O que contas whitelisted significam na operação e como melhoram continuidade.",
            es: "Qué significan operativamente las cuentas whitelisted y cómo mejoran continuidad.",
            ru: "Что означают whitelisted аккаунты в операциях и как повышают непрерывность.",
            tr: "Whitelisted hesapların operasyonel anlamı ve kampanya sürekliliğine etkisi.",
        },
        seoDescription: {
            en: "Understand whitelisted ad accounts, trust layers, escalation paths, and where they fit in high-volume media buying.",
            pt: "Entenda contas whitelisted, camadas de confiança, escalonamento e uso em mídia de alto volume.",
            es: "Entiende cuentas whitelisted, capas de confianza, escalado y uso en media buying de alto volumen.",
            ru: "Поймите whitelisted аккаунты, trust-слои, эскалацию и роль в high-volume media buying.",
            tr: "Whitelisted hesaplar, güven katmanları, eskalasyon yolu ve yüksek hacim medya satın almadaki rolünü anlayın.",
        },
        bullets: {
            en: ["Trust-layered account architecture", "Escalation channel readiness", "Policy-first campaign controls", "Continuity for high-volume teams"],
            pt: ["Arquitetura de conta com trust layer", "Prontidão de canal de escalonamento", "Controles policy-first", "Continuidade para alto volume"],
            es: ["Arquitectura con capa de confianza", "Canal de escalado listo", "Controles policy-first", "Continuidad para equipos de alto volumen"],
            ru: ["Trust-layer архитектура", "Готовность каналов эскалации", "Policy-first контроли", "Непрерывность для high-volume"],
            tr: ["Güven katmanlı hesap mimarisi", "Eskalasyon kanal hazırlığı", "Policy-first kampanya kontrolleri", "Yüksek hacimde süreklilik"],
        },
        faq: {
            en: [
                { q: "Are whitelisted accounts risk-free?", a: "No account is risk-free; whitelisted operations improve resilience with better controls." },
                { q: "Who benefits most?", a: "Teams running high spend with strict uptime and compliance requirements." },
            ],
            pt: [
                { q: "Contas whitelisted são sem risco?", a: "Não; elas aumentam resiliência com controles melhores." },
                { q: "Quem mais se beneficia?", a: "Equipes de alto spend com exigência forte de uptime e compliance." },
            ],
            es: [
                { q: "¿Las cuentas whitelisted son sin riesgo?", a: "No; mejoran resiliencia con mejores controles." },
                { q: "¿Quién se beneficia más?", a: "Equipos de alto spend con fuerte necesidad de uptime y compliance." },
            ],
            ru: [
                { q: "Whitelisted аккаунты безрисковые?", a: "Нет; они повышают устойчивость за счет лучших контролей." },
                { q: "Кому это особенно полезно?", a: "Командам с высоким расходом и жесткими требованиями к uptime и compliance." },
            ],
            tr: [
                { q: "Whitelisted hesaplar risksiz mi?", a: "Hayır; daha iyi kontrollerle dayanıklılığı artırır." },
                { q: "En çok kim fayda görür?", a: "Yüksek spend ve sıkı uptime/uyum ihtiyacı olan ekipler." },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
    "daily-spend-limit-solution": {
        title: {
            en: "Daily Spend Limit Solution",
            pt: "Solução para Limite Diário de Gasto",
            es: "Solución para Límite Diario de Gasto",
            ru: "Решение проблемы daily spend limit",
            tr: "Günlük Harcama Limiti Çözümü",
        },
        subtitle: {
            en: "How teams overcome daily spend bottlenecks with account architecture and budget distribution workflows.",
            pt: "Como equipes superam gargalos de limite diário com arquitetura de conta e distribuição de orçamento.",
            es: "Cómo superar cuellos de límite diario con arquitectura de cuenta y distribución de presupuesto.",
            ru: "Как команды обходят bottleneck daily spend limit через архитектуру аккаунтов и бюджетные workflow.",
            tr: "Ekiplerin günlük harcama limit darboğazını hesap mimarisi ve bütçe dağıtım workflow’larıyla aşması.",
        },
        seoDescription: {
            en: "Solve daily spend limit bottlenecks with structured account allocation, budget routing, and continuity operations.",
            pt: "Resolva gargalos de limite diário com alocação de contas, roteamento de orçamento e continuidade operacional.",
            es: "Resuelve límites diarios con asignación de cuentas, enrutamiento de presupuesto y continuidad operativa.",
            ru: "Решайте bottleneck daily limit через структурное распределение аккаунтов и continuity-операции.",
            tr: "Günlük limit darboğazını hesap dağıtımı, bütçe yönlendirme ve operasyon sürekliliğiyle çözün.",
        },
        bullets: {
            en: ["Account allocation strategy", "Budget routing workflow", "Spend continuity controls", "Escalation and fallback plans"],
            pt: ["Estratégia de alocação de contas", "Workflow de roteamento de orçamento", "Controles de continuidade", "Planos de escalonamento/fallback"],
            es: ["Estrategia de asignación de cuentas", "Workflow de enrutamiento de presupuesto", "Controles de continuidad", "Planes de escalado/fallback"],
            ru: ["Стратегия распределения аккаунтов", "Workflow маршрутизации бюджета", "Контроли непрерывности", "Планы эскалации/fallback"],
            tr: ["Hesap dağıtım stratejisi", "Bütçe yönlendirme workflow’u", "Spend süreklilik kontrolleri", "Eskalasyon/fallback planları"],
        },
        faq: {
            en: [
                { q: "Why does daily spend limit happen?", a: "It is usually a trust and billing profile maturity constraint within platform systems." },
                { q: "How can operations keep scaling?", a: "Through structured account distribution and controlled budget migration playbooks." },
            ],
            pt: [
                { q: "Por que acontece limite diário?", a: "Geralmente é restrição de confiança e maturidade de perfil de billing." },
                { q: "Como manter escala?", a: "Com distribuição estruturada de contas e playbooks de migração de orçamento." },
            ],
            es: [
                { q: "¿Por qué aparece límite diario?", a: "Suele ser una restricción de confianza y madurez de billing profile." },
                { q: "¿Cómo mantener escala?", a: "Con distribución estructurada de cuentas y playbooks de migración." },
            ],
            ru: [
                { q: "Почему возникает daily limit?", a: "Обычно это ограничение trust и зрелости billing-профиля." },
                { q: "Как сохранять масштаб?", a: "Через структурное распределение аккаунтов и controlled budget migration playbook." },
            ],
            tr: [
                { q: "Günlük limit neden oluşur?", a: "Genelde platform trust seviyesi ve faturalama profil olgunluğu kaynaklıdır." },
                { q: "Ölçekleme nasıl sürdürülür?", a: "Yapılandırılmış hesap dağıtımı ve kontrollü bütçe geçiş playbook’larıyla." },
            ],
        },
        image:
            "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    },
};

export const SOLUTION_SLUGS = Object.keys(SOLUTION_LANDINGS);

function localize(value, language) {
    if (!value) return "";
    return value[language] || value.en || "";
}

export function getLocalizedSolutionLanding(slug, language = "en") {
    const raw = SOLUTION_LANDINGS[slug];
    if (!raw) return null;
    return {
        slug,
        title: localize(raw.title, language),
        subtitle: localize(raw.subtitle, language),
        seoDescription: localize(raw.seoDescription, language),
        bullets: localize(raw.bullets, language) || [],
        faq: localize(raw.faq, language) || [],
        image: raw.image,
    };
}
